exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dealReceivedPage .actions .btn{margin-right:15px}.dealReceivedPage .receivedSection label{display:inline-block;width:100%;margin-bottom:0}.dealReceivedPage .estimateSection,.dealReceivedPage .headerSection,.dealReceivedPage .receivedToggle{border-bottom:1px solid #ddd;padding-bottom:15px;margin-bottom:15px}.dealReceivedPage .reverseRowShift{position:relative;bottom:15px}.dealReceivedPage .estimateSelector{width:50%;margin-bottom:15px}.dealReceivedPage .receivedToggle label{display:inline-block;margin-bottom:5px}.dealReceivedPage .receivedToggle input{position:relative;bottom:2px;margin-right:10px}.dealReceivedPage .receivedSection .row{margin-bottom:15px}.dealReceivedPage .helperText{font-weight:400;font-size:.8em;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/crm/deal_received_page.scss
// module id = 811
// module chunks = 0